import { SearcherId } from "../../../types/common/searchers.js";
export const SearcherNameToId = {
    'searcher-car': SearcherId.CAR,
    'm-searcher-car': SearcherId.CAR,
    'searcher-cir': SearcherId.CIR,
    'm-searcher-cir': SearcherId.CIR,
    'searcher-cru': SearcherId.CRU,
    'm-searcher-cru': SearcherId.CRU,
    'searcher-disney': SearcherId.DIS,
    'searcher-ferry': SearcherId.FER,
    'm-searcher-fer': SearcherId.FER,
    'searcher-ferry-rxjs': SearcherId.FER_HOT,
    'm-searcher-ferry-hotel': SearcherId.FER_HOT,
    'searcher-fli': SearcherId.FLI,
    'm-searcher-fli': SearcherId.FLI,
    searcherFlightHotel: SearcherId.FLI_HOT,
    'searcher-flight-hotel-rxjs': SearcherId.FLI_HOT,
    'searcher-flight-hotel': SearcherId.FLI_HOT,
    'm-searcher-flight-hotel': SearcherId.FLI_HOT,
    'searcher-hotels': SearcherId.HOT,
    'm-searcher-hotels': SearcherId.HOT,
    'searcher-lei-rxjs': SearcherId.LEI,
    'm-searcher-lei-rxjs': SearcherId.LEI,
    'searcher-multi-pak': SearcherId.MUL_PAK,
    'm-searcher-multi-pak': SearcherId.MUL_PAK,
    searcherTou: SearcherId.TOU,
    'searcher-tou': SearcherId.TOU,
    'm-searcher-tou': SearcherId.TOU,
    'searcher-train': SearcherId.TRA,
    'm-searcher-tra': SearcherId.TRA,
    searcherTrainHotel: SearcherId.TRA_HOT,
    'searcher-train-rxjs': SearcherId.TRA_HOT,
    'searcher-train-hotel': SearcherId.TRA_HOT,
    'm-searcher-train-hotel': SearcherId.TRA_HOT,
    searcherFerryHotel: SearcherId.FER_HOT,
    'searcher-destination-pak': SearcherId.DEST,
    'searcher-destination': SearcherId.DEST,
    'm-searcher-destination-pak': SearcherId.DEST,
    'm-searcher-destination': SearcherId.DEST
};

//# sourceMappingURL=constants.js.map